import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './Timer.css';

const MINUTE = 60;

export default function Timer({
  start,
  ev,
}) {
  const [time, setTime] = useState({ min: '00', sec: '00' });

  useEffect(() => {
    const intv = setInterval(
      () => {
        const diff = (Date.now() - start) / 1000;
        const min = Math.floor(diff / MINUTE).toString().padStart(2, '0');
        const sec = Math.floor(diff - min * MINUTE).toString().padStart(2, '0');

        setTime({ min, sec });
      }, 1000,
    );
    return () => clearInterval(intv);
  }, [time]);

  return (
    <div className="timer">
      <div className="col">
        <span>{`${time.min}:${time.sec}`}</span>
        <span>min:sec</span>
        <br />
        <span>{ev}</span>
        <span>HR exceeded</span>
      </div>
    </div>
  );
}

Timer.propTypes = {
  ev: PropTypes.string.isRequired,
  start: PropTypes.number.isRequired,
};
